
import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <>
      {/* Page Header */}
      <section className="relative py-24 lg:py-32 bg-gray-900" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1920&q=80')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">About JobsDriver</h1>
          <div className="flex items-center justify-center text-gray-200 text-lg">
            <Link to="/" className="hover:text-white transition-colors duration-200">Home</Link>
            <i className="fas fa-chevron-right mx-3"></i>
            <span className="text-white">About Us</span>
          </div>
        </div>
      </section>

      {/* About Intro Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=600&q=80" alt="JobsDriver Team" className="w-full h-auto rounded-xl shadow-2xl" />
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Your Ultimate Job Directory in UAE</h2>
              <p className="text-lg text-gray-600 mb-6">JobsDriver is the leading job portal in the UAE, connecting talented job seekers with top employers across Dubai and the entire United Arab Emirates. Our mission is to simplify the job search process and help professionals find their dream careers.</p>
              <p className="text-lg text-gray-600 mb-8">Founded in 2020, JobsDriver has quickly grown to become one of the most trusted job platforms in the region, with thousands of job listings across various industries and sectors.</p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-primary-600 mb-2">10,000+</div>
                  <div className="text-gray-600 font-medium">Active Jobs</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-primary-600 mb-2">5,000+</div>
                  <div className="text-gray-600 font-medium">Companies</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-primary-600 mb-2">500,000+</div>
                  <div className="text-gray-600 font-medium">Job Seekers</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-primary-600 mb-2">8,500+</div>
                  <div className="text-gray-600 font-medium">Successful Hires</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Our Mission & Vision</h2>
              <div className="space-y-8">
                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                  <h3 className="flex items-center text-xl font-semibold text-gray-900 mb-4">
                    <i className="fas fa-bullseye text-primary-600 mr-3"></i> Our Mission
                  </h3>
                  <p className="text-gray-600 leading-relaxed">To connect job seekers with their ideal employers by providing a comprehensive, user-friendly platform that simplifies the job search process and helps companies find the perfect candidates for their vacancies.</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                  <h3 className="flex items-center text-xl font-semibold text-gray-900 mb-4">
                    <i className="fas fa-eye text-primary-600 mr-3"></i> Our Vision
                  </h3>
                  <p className="text-gray-600 leading-relaxed">To be the leading job portal in the Middle East, revolutionizing how people find employment and how companies recruit talent, while contributing to the economic growth and workforce development of the UAE.</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                  <h3 className="flex items-center text-xl font-semibold text-gray-900 mb-4">
                    <i className="fas fa-star text-primary-600 mr-3"></i> Our Values
                  </h3>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-start">
                      <span className="font-semibold text-gray-900 mr-2">Excellence:</span>
                      <span>We strive for excellence in everything we do</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-semibold text-gray-900 mr-2">Innovation:</span>
                      <span>We continuously innovate to improve our services</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-semibold text-gray-900 mr-2">Integrity:</span>
                      <span>We operate with honesty and transparency</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-semibold text-gray-900 mr-2">Diversity:</span>
                      <span>We embrace diversity and inclusion in the workplace</span>
                    </li>
                    <li className="flex items-start">
                      <span className="font-semibold text-gray-900 mr-2">User-Centric:</span>
                      <span>We put our users' needs at the center of our decisions</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=600&q=80" alt="Team Meeting" className="w-full h-auto rounded-xl shadow-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Why Choose JobsDriver</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">What makes us different from other job portals</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <div className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-search text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Comprehensive Job Listings</h3>
              <p className="text-gray-600 leading-relaxed">Access thousands of verified job opportunities across all industries and sectors in the UAE.</p>
            </div>

            <div className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-filter text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Advanced Search Filters</h3>
              <p className="text-gray-600 leading-relaxed">Find exactly what you're looking for with our powerful search and filtering options.</p>
            </div>

            <div className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-bell text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Job Alerts</h3>
              <p className="text-gray-600 leading-relaxed">Receive notifications about new job opportunities that match your preferences and skills.</p>
            </div>

            <div className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-building text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Verified Employers</h3>
              <p className="text-gray-600 leading-relaxed">Apply with confidence knowing that all employers on our platform are verified and legitimate.</p>
            </div>

            <div className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-mobile-alt text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Mobile-Friendly Platform</h3>
              <p className="text-gray-600 leading-relaxed">Search for jobs and apply on-the-go with our responsive, mobile-optimized website.</p>
            </div>

            <div className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-book text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Career Resources</h3>
              <p className="text-gray-600 leading-relaxed">Access helpful guides, tips, and resources to help you succeed in your job search and career.</p>
            </div>
          </div>

          {/* Ad Banner */}
          <div className="ad-banner text-center mb-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              style={{width:'300px', height:'250px'}} 
              frameBorder="0" 
              scrolling="no" 
              title="Trip.com Advertisement"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">The dedicated professionals behind JobsDriver</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-w-1 aspect-h-1">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=400&q=80" alt="Ahmed Al Mansouri" className="w-full h-64 object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">Ahmed Al Mansouri</h3>
                <p className="text-primary-600 font-medium mb-3">Founder & CEO</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">With over 15 years of experience in HR and recruitment, Ahmed founded JobsDriver with a vision to transform the job market in UAE.</p>
                <div className="flex space-x-3">
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-linkedin-in text-sm"></i>
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-twitter text-sm"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-w-1 aspect-h-1">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=400&q=80" alt="Sarah Johnson" className="w-full h-64 object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">Sarah Johnson</h3>
                <p className="text-primary-600 font-medium mb-3">Chief Operations Officer</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">Sarah oversees the day-to-day operations of JobsDriver, ensuring that both job seekers and employers have a seamless experience.</p>
                <div className="flex space-x-3">
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-linkedin-in text-sm"></i>
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-twitter text-sm"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-w-1 aspect-h-1">
                <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=400&q=80" alt="Mohammed Al Hashimi" className="w-full h-64 object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">Mohammed Al Hashimi</h3>
                <p className="text-primary-600 font-medium mb-3">Chief Technology Officer</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">Mohammed leads our technology team, developing innovative solutions to make job searching and recruitment more efficient.</p>
                <div className="flex space-x-3">
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-linkedin-in text-sm"></i>
                  </a>
                  <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-github text-sm"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-w-1 aspect-h-1">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=400&q=80" alt="Fatima Al Zaabi" className="w-full h-64 object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">Fatima Al Zaabi</h3>
                <p className="text-primary-600 font-medium mb-3">Head of Marketing</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">Fatima drives our marketing strategies, helping JobsDriver reach more job seekers and employers across the UAE.</p>
                <div className="flex space-x-3">
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-linkedin-in text-sm"></i>
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors duration-200">
                    <i className="fab fa-instagram text-sm"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">What Our Users Say</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">Success stories from job seekers and employers</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="mb-6">
                <div className="flex text-yellow-400 mb-4">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <p className="text-gray-600 leading-relaxed">"JobsDriver helped me find my dream job at one of Dubai's top tech companies. The platform is user-friendly and has a wide range of job listings. I highly recommend it to anyone looking for new opportunities in the UAE."</p>
              </div>
              <div className="flex items-center">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80" alt="John Smith" className="w-12 h-12 rounded-full object-cover mr-4" />
                <div>
                  <h4 className="font-semibold text-gray-900">John Smith</h4>
                  <p className="text-gray-600 text-sm">Software Developer</p>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="mb-6">
                <div className="flex text-yellow-400 mb-4">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <p className="text-gray-600 leading-relaxed">"As an HR manager, I've used several job portals, but JobsDriver stands out for its quality candidates and excellent customer service. We've hired multiple talented professionals through the platform and will continue to use it for our recruitment needs."</p>
              </div>
              <div className="flex items-center">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80" alt="Lisa Chen" className="w-12 h-12 rounded-full object-cover mr-4" />
                <div>
                  <h4 className="font-semibold text-gray-900">Lisa Chen</h4>
                  <p className="text-gray-600 text-sm">HR Manager, Global Solutions</p>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="mb-6">
                <div className="flex text-yellow-400 mb-4">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star-half-alt"></i>
                </div>
                <p className="text-gray-600 leading-relaxed">"After moving to Dubai, I was struggling to find job opportunities in my field. JobsDriver not only helped me find relevant positions but also provided valuable resources on how to tailor my resume for the UAE market. I secured a great position within a month!"</p>
              </div>
              <div className="flex items-center">
                <img src="https://images.unsplash.com/photo-1463453091185-61582044d556?auto=format&fit=crop&w=100&q=80" alt="Raj Patel" className="w-12 h-12 rounded-full object-cover mr-4" />
                <div>
                  <h4 className="font-semibold text-gray-900">Raj Patel</h4>
                  <p className="text-gray-600 text-sm">Marketing Specialist</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-16 lg:py-24 bg-primary-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Have Questions?</h2>
            <p className="text-xl text-primary-100 max-w-2xl mx-auto">Our team is here to help you with any questions or concerns you may have about JobsDriver.</p>
          </div>
          <Link to="/contact" className="inline-flex items-center px-8 py-3 bg-white text-primary-600 font-semibold rounded-lg hover:bg-gray-100 transition-all duration-200 transform hover:scale-105">
            Contact Us
          </Link>
        </div>
      </section>
    </>
  );
};

export default About;
